import * as userAccount from '../actionTypes/Accounts/userAccounts'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'

function getAccountSuccess (userAccounts) {
  return {
    type: userAccount.GET_ADMIN_ACCOUNT,
    userAccounts: userAccounts
  }
}

function getAccountListSuccess (userAccountsList) {
  return {
    type: userAccount.GET_ADMIN_ACCOUNT_LIST,
    userAccountsList: userAccountsList
  }
}

export const getUserAccountDetails = (uuid, callBack) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAdminAcount + '?uuid=' + uuid
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, data => {
      let accountData = data.data
      dispatch(getAccountSuccess(accountData))
      callBack(accountData)
    })
  }
}
// Search accounts
export const setAccountSearchParams = (searchParams) => {
  return {
    type: userAccount.SET_SEARCH_PARAMS_ACCOUNTS,
    searchParams: searchParams
  }
}

export const getUserAccountList = (data, callBack) => {
  let page = (data.page !== 0) ? data.page : 1
  let pagenumber = '?PageNumber=' + page
  let sortcolumn = '&sortcolumn=' + data.sc
  let SortingType = '&SortingType=' + data.st
  let RecordPerPage = '&RecordPerPage=' + data.perPage
  return (dispatch, getState) => {
    const api = new Api()
    const state = getState()
    let query = pagenumber + '&criteria=' + escape(encodeURIComponent(state.userAccounts.searchParams.criteria)) + '&filter=' + state.userAccounts.searchParams.filter + sortcolumn + SortingType + RecordPerPage
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAdminAccounts + query
    api.getData(url, data => {
      let accountData = data.data
      dispatch(getAccountListSuccess(accountData))
      callBack(accountData)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/userAccounts.js